import React, { ReactNode } from 'react';
import { Tooltip } from '../tooltip/Tooltip';
import { Space } from '../space/Space';
import { Button, ButtonToolbar, Classes, EventProps, Icon } from '../index';
import { formatTimeRange } from './utils';
import { mcDelete, mcEdit } from '@mc/react-ui-icons';
import { Locale } from 'date-fns';

type CalendarEventTooltipProps<ID> = {
  trigger: React.JSX.Element;
  event?: EventProps<ID>;
  onEdit?: () => void;
  onDelete?: () => void;
  locale: Locale;
  /**
   * Vlastní tooltip eventu
   * @param event
   */
  customEventTooltip?: (event?: EventProps<ID>) => ReactNode;
};

export const CalendarEventTooltip = <ID extends unknown = {}>({
  trigger,
  event,
  onEdit,
  onDelete,
  locale,
  customEventTooltip,
}: CalendarEventTooltipProps<ID>) => {
  return (
    <Tooltip closable noStopPropagation noPreventDefault trigger={trigger}>
      {({ onClose }) => {
        return (
          <div>
            {customEventTooltip ? (
              customEventTooltip(event)
            ) : (
              <Space
                className={Classes.CALENDAR_EVENT_TOOLTIP}
                size={'1'}
                vertical
              >
                <div className={'d-flex w-100'}>
                  <div className={'w-100'}>
                    {event?.title && (
                      <span className={Classes.CALENDAR_EVENT_TOOLTIP_TITLE}>
                        {event.title}
                      </span>
                    )}
                  </div>
                </div>
                {event && (
                  <span className={Classes.CALENDAR_EVENT_TOOLTIP_TIMERANGE}>
                    {formatTimeRange(event, locale, false)}
                  </span>
                )}
                {event?.description && (
                  <span className={Classes.CALENDAR_EVENT_TOOLTIP_DESCRIPTION}>
                    {event.description}
                  </span>
                )}
              </Space>
            )}
            {!event?.disabled && (
              <div className={'d-flex'}>
                <ButtonToolbar className={'mt-2'}>
                  <Button
                    title={'Odstranit'}
                    danger
                    style={'link'}
                    icon={<Icon fixedWidth icon={mcDelete} />}
                    onClick={() => {
                      onClose();
                      onDelete?.();
                    }}
                  />
                  <Button
                    title={'Upravit'}
                    style={'link'}
                    icon={<Icon fixedWidth icon={mcEdit} />}
                    onClick={() => {
                      onClose();
                      onEdit?.();
                    }}
                  />
                </ButtonToolbar>
              </div>
            )}
          </div>
        );
      }}
    </Tooltip>
  );
};
